import {
  readRecords,
  writeRecords,
} from '../../shared/storage/localRecords';

export function createEmptyRangerRecordState() {
  return {
    bestScore: 0,
    bestByMission: {},
    fastestByMission: {},
    fewestAlertsByMission: {},
    bestByClass: {},
    completedMissions: [],
    badges: {},
  };
}

export function normalizeRangerRecords(records = {}) {
  const emptyNormal = createEmptyRangerRecordState();
  const normal = records.normal ?? {};

  return {
    ...records,
    normal: {
      ...normal,
      bestScore: Math.max(normal.bestScore ?? 0, normal.bestScore ?? 0),
      bestByMission: normal.bestByMission ?? {},
      fastestByMission: normal.fastestByMission ?? {},
      fewestAlertsByMission: normal.fewestAlertsByMission ?? {},
      bestByClass: normal.bestByClass ?? {},
      completedMissions: normal.completedMissions ?? normal.completedSectors ?? emptyNormal.completedMissions,
      badges: normal.badges ?? {},
    },
  };
}

function sortMissionIds(missionIds) {
  return [...new Set(missionIds)].sort((left, right) => left.localeCompare(right));
}

export function updateRangerRecordsForMission(records, missionResult) {
  const normalized = normalizeRangerRecords(records);
  const normal = normalized.normal;
  const {
    missionId,
    score = 0,
    elapsedMs = 0,
    alertCount = 0,
    selectedClassId = 'ranger',
    rank = 'clear',
  } = missionResult;

  if (!missionId) {
    return normalized;
  }

  return {
    ...normalized,
    normal: {
      ...normal,
      bestScore: Math.max(normal.bestScore ?? 0, score),
      bestByMission: {
        ...normal.bestByMission,
        [missionId]: Math.max(normal.bestByMission?.[missionId] ?? 0, score),
      },
      fastestByMission: {
        ...normal.fastestByMission,
        [missionId]: Math.min(normal.fastestByMission?.[missionId] ?? Infinity, elapsedMs),
      },
      fewestAlertsByMission: {
        ...normal.fewestAlertsByMission,
        [missionId]: Math.min(normal.fewestAlertsByMission?.[missionId] ?? Infinity, alertCount),
      },
      bestByClass: {
        ...normal.bestByClass,
        [selectedClassId]: Math.max(normal.bestByClass?.[selectedClassId] ?? 0, score),
      },
      completedMissions: sortMissionIds([
        ...(normal.completedMissions ?? []),
        missionId,
      ]),
      badges: {
        ...normal.badges,
        [missionId]: rank,
      },
    },
  };
}

export function readRangerRecords(storage = window.localStorage) {
  return normalizeRangerRecords(readRecords(storage, 'ranger'));
}

export function writeRangerRecords(records, storage = window.localStorage) {
  writeRecords(normalizeRangerRecords(records), storage, 'ranger');
}
